import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer'
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getList } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput'
import SelectInput from '../../components/common/SelectInput'
import { Edit } from '@mui/icons-material'
import { connect } from 'react-redux';
import CustomDataGrid from '../../components/CustomDataGrid';

const Users = ({ user }) => {

    const defaultUser = {
        "name": "",
        "userID": "",
        "email": "",
        "phoneNumber": "",
        "roleID": "",
        "active": true,
        "institutionID": ""
    }
    
    const [ showModal, setShowModal ] = useState(false)
    const [ isEditing, setEditing ] = useState(false)
    const [ processing, setProcessing ] = useState(false)
    const [ userData, setUserData ] = useState({});
    const [ selectedUser, setSelectedUser ] = useState(defaultUser);
    const [ users, setUsers ] = useState([]);
    const [ institutions, setInstitutions ] = useState([]);
    const [ roles, setRoles ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    

    const columns = [
        { 
            field: 'sn', headerName: 'S/N', width: 80, sortable: false,
            renderCell: (params) => (
                <p
                    style={{ margin: 'auto' }}
                >
                    {params?.row?.sn}
                </p>
            )
        },
        {
            field: 'actions', headerName: 'Actions', width: 100, sortable: false,
            renderCell: (params) => (
                <div className='action-icons' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%', padding: '0 0.5rem' }}>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Edit Dataset Domain' className='p-0 m-0'
                        onClick={() => {
                            setSelectedUser(params?.row || defaultUser);
                            setEditing(true);
                            setShowModal(true)
                        }}
                    >
                        <Edit />
                    </IconButton>
                </div>
            )
        },
        { field: 'userID', headerName: 'User ID', width: 300 },
        { field: 'name', headerName: 'Full Name', width: 300 },
        {
            field: 'email',
            headerName: 'Email Address',
            width: 300,
        },
        {
            field: 'roleName',
            headerName: 'Role',
            width: 300,
        },
        {
            field: 'institutionName',
            headerName: 'Institution',
            width: 300,
        },
        {
            field: 'active',
            headerName: 'Is Active',
            width: 300,
            valueGetter: ({ row }) => row?.active ? 'True' : 'False'
        },
    ];

    const init = async () => {
        try {
            setProcessing(true)
            const resp = await getList("users");
            if(resp?.responseCode === "00") {
                setUsers(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const getInstitutions = async () => {
        try {
            const resp = await getList("institutions");
            if(resp?.responseCode === "00") {
                setInstitutions(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    const getRoles = async () => {
        try {
            const resp = await getList("roles");
            if(resp?.responseCode === "00") {
                setRoles(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    const createOrUpdateUser = async (values, { resetForm }) => {
        try {
            const resp = await AddorUpdateRecord("user", isEditing ? "update" : 'add', values);
            if(resp?.responseCode === "00") {
                init();
                setShowModal(false);
                setSelectedUser(null);
                setEditing(false);
                enqueueSnackbar('Action performed successfully');
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    useEffect(() => {
        init()
        getInstitutions()
        getRoles()
    }, [])

    useEffect(() => {
        setUserData(user?.userData)
    }, [user])
    
    return (
        <PageContainer pageTitle='Users' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">All</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Users</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 text-align-right'>
                            <Button variant="contained" onClick={() => { setSelectedUser(defaultUser); setEditing(false); setShowModal(true) }}>Create New User</Button>
                        </div>
                        <div className='col-12 mt-4'>
                            <div style={{ height: 600, width: '100%', textAlign: 'center' }}>
                                <CustomDataGrid 
                                    columns={columns}
                                    rows={users}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog open={showModal}>
                <Formik enableReinitialize 
                    initialValues={{ 
                        ...selectedUser, active: String(selectedUser?.active),
                        institutionID: (userData?.roleID == 2 || userData?.roleID == 3) ? "" : selectedUser.institutionID
                    }} 
                    onSubmit={createOrUpdateUser}
                >
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent className='pl-3 pr-3'>
                                <h3 className='text-bold mt-05' >{isEditing ? 'Update' : 'Create'} User</h3>
                                <Divider className="mt-05 mb-2" />
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextInput id="userID" readOnly={selectedUser?.userID} required label="User ID" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="name" required label="Full name" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="email" label="Email Address" type="email" required />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectInput required id="roleID" label="Role" options={roles} field="roleID" fieldDisplay='roleName' />
                                    </Grid>
                                    {
                                        !Boolean((userData?.roleID == 2 || userData?.roleID == 3)) &&
                                        <Grid item xs={12}>
                                            <SelectInput required id="institutionID" label="Institution" field="id" options={institutions} fieldDisplay='institutionName' />
                                        </Grid>
                                    }
                                    <Grid item xs={12}>
                                        <TextInput required id="phoneNumber" label="Phone"  />
                                    </Grid>
                                    
                                    {
                                        isEditing &&
                                        <Grid item xs={12}>
                                            <SelectInput id="active" label="Account status" field="code" fieldDisplay='name' 
                                                options={[
                                                    { code: 'true', name: 'Active' },
                                                    { code: 'false', name: 'Inactive' }
                                                ]}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                            </DialogContent>
                            <DialogActions className='pr-3 pb-3'>
                                <Button disabled={isSubmitting} onClick={() => { if(!isSubmitting) { setShowModal(false); setEditing(false); setSelectedUser(null) }}} color="secondary" variant="contained" >Cancel</Button>
                                <Button type='submit' variant="contained" disabled={isSubmitting}>
                                    {
                                        isSubmitting ?
                                        <CircularProgress size={15} color="inherit" />
                                        :
                                        isEditing ? 'Update User' : 'Add User'
                                    }
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </PageContainer>
    )
}

export default connect(({ user }) => ({ user }))(Users)